'use client';

import { toast } from 'src/components/snackbar';

import { registreraFel } from './felbutik';
import { begärRapportdialog } from './rapportdialog';

/**
 * Gemensam felvisning.
 *
 * Idag toastar varje anropsställe sin egen sträng med sin egen reservtext ("Ett fel uppstod",
 * "Något gick fel", "Ett oväntat fel uppstod"). Den här hjälparen finns för att de stegvis ska
 * kunna samlas på ett ställe — den migreringen ingår inte i den här ändringen, men helt nya
 * anropsställen bör använda `visaFel` direkt.
 */

/** Markering på felobjektet så att interceptorn och anropsstället inte dubbeltoastar. */
const HANTERAT = '__felVisat';

export function ärRedanVisat(fel: any): boolean {
  return Boolean(fel?.[HANTERAT]);
}

export function markeraSomVisat(fel: any): void {
  try {
    if (fel && typeof fel === 'object') {
      Object.defineProperty(fel, HANTERAT, { value: true, enumerable: false });
    }
  } catch {
    // Frusna objekt går inte att märka. Värsta utfallet är en toast för mycket.
  }
}

export function meddelandeUrFel(fel: any, reservtext = 'Något gick fel'): string {
  return fel?.response?.data?.message || fel?.message || reservtext;
}

export function referensUrFel(fel: any): string | undefined {
  return (
    fel?.response?.data?.felReferens ||
    fel?.response?.headers?.['x-fel-referens'] ||
    undefined
  );
}

/**
 * Visar ett fel för användaren och erbjuder rapportering när det finns en referens att
 * rapportera på. Utan referens finns inget att felsöka och knappen vore ett tomt löfte.
 */
export function visaFel(fel: any, reservtext?: string): void {
  if (ärRedanVisat(fel)) {
    return;
  }
  markeraSomVisat(fel);

  const meddelande = meddelandeUrFel(fel, reservtext);
  const referens = referensUrFel(fel);

  registreraFel({
    referens,
    meddelande,
    tidpunkt: new Date(),
    sökväg: typeof window !== 'undefined' ? window.location.pathname : undefined,
    anrop: fel?.config?.url,
    status: fel?.response?.status,
  });

  toast.error(meddelande, {
    // Stabilt id: en anropsstorm mot samma trasiga endpoint kollapsar till en toast.
    id: referens ?? `fel-${fel?.config?.url ?? 'okänt'}`,
    duration: 8000,
    ...(referens
      ? {
          action: {
            label: 'Rapportera',
            onClick: () => begärRapportdialog(),
          },
        }
      : {}),
  });
}
